import { render, staticRenderFns } from "./V2ClearCartsModal.vue?vue&type=template&id=299f6b80&scoped=true&"
import script from "./V2ClearCartsModal.vue?vue&type=script&lang=js&"
export * from "./V2ClearCartsModal.vue?vue&type=script&lang=js&"
import style0 from "./V2ClearCartsModal.vue?vue&type=style&index=0&id=299f6b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f6b80",
  null
  
)

export default component.exports